"use strict";

($dt => {
	
	const controller = {

		registered_blocks: [],
		
		/**
		 * This is called for each block matching this type
		 * @param {HTMLElement} container 
		 */
		LoadBlock: container => {
			const [ school_input_elem ] = [
				container.querySelector('input[name="school"]')
			];

			if (school_input_elem) {
				// When using input for school, we can assume auto completer is enabled.
				const block = {
					autocompleter: $dt.Schools.CreateNewSchoolAutoCompleter(school_input_elem),
					container: container,
					school_input_elem: school_input_elem
				};

				if (controller.registered_blocks.length === 0) {
					$dt.OnDevelformsReady($df => {
						$df.RegisterFormPreparedEvent('register', form => {
							form.prePost = data => {
								// This event will fire for any register form on the page, so we need to find the auto completer within this form
								const form_container = form.currentContainer;
								const form_school_input_elem = form_container.querySelector('input[name="school"]');
								const form_block = controller.registered_blocks.find(b => { return b.school_input_elem === form_school_input_elem; });
								if (form_block) {
									data.school = form_block.autocompleter.current_id ? form_block.autocompleter.current_id : -1;
								} else {
									console.warn('The correct autocompleter couldn\'t be found for this form element.');
								}

								return (form_block);
							};
						});
					});
				}

				controller.registered_blocks.push(block);
			}
		}
		
	};

	$dt.blocks['educator-signup'] = controller;
	
})(window.d3_wp_themejs);
